import { render, staticRenderFns } from "./multipleCreate.vue?vue&type=template&id=493c08aa&scoped=true&"
import script from "./multipleCreate.vue?vue&type=script&lang=js&"
export * from "./multipleCreate.vue?vue&type=script&lang=js&"
import style0 from "./multipleCreate.vue?vue&type=style&index=0&id=493c08aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "493c08aa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VBtn,VCard,VForm})
